export default "__VITE_ASSET__Bla7a$8O__"